import PropTypes from 'prop-types';
export const RadioButtonDefaultProps = {
    checked: false,
    disabled: false,
    label: '',
    value: '',
    id: ''
};
export const RadioButtonPropTypes = {
    /** Define state of button */
    checked: PropTypes.bool,
    /** Callback function */
    onClick: PropTypes.func,
    /** Disabled boolean */
    disabled: PropTypes.bool,
    /** Value to return */
    value: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string
};
//# sourceMappingURL=RadioButton.prop-types.js.map